import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menuFlod",
  "use": "icon-menuFlod-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-menuFlod\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" /> \n\t<path d=\"M20,6.5H12v2h8Zm0,5H12v2h8Zm0,5H4v2H20ZM4,10l5,4.5v-9Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol